import { render, staticRenderFns } from "./LocusZoomCatalogAnnotationsPanel.vue?vue&type=template&id=7e461092&"
import script from "./LocusZoomCatalogAnnotationsPanel.vue?vue&type=script&lang=js&"
export * from "./LocusZoomCatalogAnnotationsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e461092')) {
      api.createRecord('7e461092', component.options)
    } else {
      api.reload('7e461092', component.options)
    }
    module.hot.accept("./LocusZoomCatalogAnnotationsPanel.vue?vue&type=template&id=7e461092&", function () {
      api.rerender('7e461092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lz/panels/LocusZoomCatalogAnnotationsPanel.vue"
export default component.exports